module.exports = __webpack_public_path__ + "media/images/clutch_kits/clutch_disc-3e9ba8276c3cef58a247f3305754f117.jpg";